
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

export const AirportNotFound = () => {
  const { t } = useTranslation();
  
  return (
    <div className="text-center py-12">
      <h2 className="text-xl font-semibold mb-2">{t('airport_not_found')}</h2>
      <Link to="/">
        <Button>{t('return_home')}</Button>
      </Link>
    </div>
  );
};
